<template>
    <MobileHeader></MobileHeader>
    <div
        class="container has-header analysis-container"
        :class="$route.params.type"
    >
        <LeagueStanding v-if="$route.params.type === 'league-standings'" />
        <LeagueStatsComparisonLastNMatchesStatVue
            v-else-if="$route.params.type === 'league-stats-comparison'"
        />
        <LeagueSquad v-else-if="$route.params.type === 'squad-status'" />
        <PlayerPerformance2
            v-else-if="$route.params.type === 'player-peformance'"
        />
        <LeagueTrend v-else-if="$route.params.type === 'league-trend'" />
    </div>
</template>

<script>
import MobileHeader from "@/components/mobile/Header.vue";
import LeagueStanding from "./LeagueStanding.vue";
import LeagueStatsComparisonLastNMatchesStatVue from "./LeagueStatsComparison-LastNMatchesStat.vue.vue";
import LeagueSquad from "./LeagueSquad.vue";
import PlayerPerformance2 from "./PlayerPeformance.vue";
import LeagueTrend from "./LeagueTrend.vue";
import { mapGetters } from "vuex";
export default {
    name: "AnalysisDetails",
    data() {
        return {};
    },
    components: {
        MobileHeader,
        LeagueStanding,
        LeagueStatsComparisonLastNMatchesStatVue,
        LeagueSquad,
        PlayerPerformance2,
        LeagueTrend,
    },
    computed: {
        ...mapGetters(["isMobile", "currentLocale", "currentSportType"]),
    },
    watch: {
        isMobile(isMobile) {
            if (!isMobile) {
                let params = this.$route.params;
                this.$router.push(
                    `/${params.locale}/${this.currentSportType}/${params.country}/${params.club}/${params.opponent}/${params.matchId}/analysis/details`
                );
            }
        },
    },
};
</script>

<style scoped>
.analysis-container {
    padding: 16px 8px;
}
.analysis-container.squad-status {
    padding: 0 0 16px;
}
.analysis-container.player-peformance {
    padding: 0 0 16px;
}
</style>
